module.exports = __webpack_public_path__ + "img/questionnaire_device_pt-br.8ee3ab50.png";